<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    深外高中站<br>
站点介绍<br>
深外高中站位于中青一路和盐田路交汇处，盐排高速和梧桐山大道西侧，车站沿中青一路西南、东北走向，东北接盐田路站，西南接盐田港西站。 深外高中站为特色站，根据穹顶的特殊建筑形态打造空间，两侧以变化的穿孔板体现“临山”主题概念，为地下四层站，其中地下一层和地下二层为设备层，地下三层为站厅层，地下四层为站台层，站台形式为岛式站台。车站设置有3个出入口，临近深圳外国语学校，周边为海桐居、云顶道等成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	23:12	8号线	5分10秒	5分45秒<br>
盐田路	06:49	00:29	8号线	5分10秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	23:12	8号线	4分钟	5分钟<br>
盐田路	06:49	00:28	8号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
梧桐山南	06:02	00:02	8号线	4分钟	5分钟<br>
盐田路	06:49	01:28	8号线	4分钟	5分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
深圳外国语学校高中部<br><br>
B1出入口:<br>
梧桐山大道南侧（东）<br><br>
C出入口:<br>
中青一路、海桐社区党群服务中心、中海双语幼儿园、云海学校、深圳地铁望基湖停车场<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 深圳外国语学校西<br>
M348、M444、M465、B982、B925<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "bahaoxian",
          title: "8号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>